import Markdown, { Components } from "react-markdown";
import styled from "@emotion/styled";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const MarkdownContainer = styled.div`
  p {
    margin: 0;
    padding: 0;
  }
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.sm};

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1em 0;
    overflow-x: auto;
    display: block;
  }
  th,
  td {
    border: 1px solid ${({ theme }) => theme.colors.component.border[1]};
    padding: 0.5em 1em;
    text-align: left;
    background: ${({ theme }) => theme.colors.component.background[2]};
  }
  th {
    background: ${({ theme }) => theme.colors.component.background[3]};
    font-weight: bold;
  }
  tr:nth-of-type(even) td {
    background: ${({ theme }) => theme.colors.component.background[3]};
  }
`;

const markdownComponents: Components = {
  a: (props: { href?: string; children?: React.ReactNode }) => (
    <a href={props.href} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  ),
};

type MarkdownViewerProps = {
  content: string;
};

export const MarkdownViewer = ({ content }: MarkdownViewerProps) => (
  <MarkdownContainer>
    <Markdown
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      components={markdownComponents}
    >
      {content}
    </Markdown>
  </MarkdownContainer>
);
